function updateCartUI() {
  fetch(window.location.href)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // --- Update Cart Drawer ---
      const newDrawer = doc.querySelector("#CartDrawer");
      const currentDrawer = document.querySelector("#CartDrawer");
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      // --- Update Cart Icon Bubble ---
      const newBubble = doc.querySelector("#cart-icon-bubble");
      const currentBubble = document.querySelector("#cart-icon-bubble");
      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }

      // --- Update Cart Page Footer ---
      const newFooter = doc.querySelector("#main-cart-footer");
      const currentFooter = document.querySelector("#main-cart-footer");
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }

      // --- Update Cart Page Items List ---
      const newCartItems = doc.querySelector(".cart__items, #main-cart-items");
      const currentCartItems = document.querySelector(".cart__items, #main-cart-items");
      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }

      // ✅ Ensure gift wrap checkbox reflects actual cart contents
      syncGiftWrapCheckboxWithCartLive();

      // ✅ Rebind checkbox change event after replacing HTML
      bindGiftWrappingEvent();
    });
}

// ✅ Check actual cart contents (via /cart.js) instead of just page HTML
function syncGiftWrapCheckboxWithCartLive() {
  let wc_gift_wrap_checkbox = document.querySelector("#giftWrappingCheckbox");
  if (!wc_gift_wrap_checkbox) return;

  let wc_gift_variant_id = parseInt(wc_gift_wrap_checkbox.value, 10);

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      let giftWrapInCart = cart.items.some(item => item.variant_id === wc_gift_variant_id);
      wc_gift_wrap_checkbox.checked = giftWrapInCart;
    });
}

// ✅ Toggle Gift Wrapping Product
let toggleGiftWrapping = (checkbox) => {
  let wc_gift_variant_id = checkbox.value;

  if (checkbox.checked) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: wc_gift_variant_id, quantity: 1 }),
    })
      .then((res) => res.json())
      .then(() => {
        updateCartUI();
      })
      .catch(() => {
        checkbox.checked = false;
      });
  } else {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: wc_gift_variant_id, quantity: 0 }),
    })
      .then((res) => res.json())
      .then(() => {
        updateCartUI();
      })
      .catch(() => {
        checkbox.checked = true;
      });
  }
};

// ✅ Bind Event to Gift Wrapping Checkbox
let bindGiftWrappingEvent = () => {
  let wc_gift_wrap_checkbox = document.querySelector("#giftWrappingCheckbox");
  if (wc_gift_wrap_checkbox) {
    wc_gift_wrap_checkbox.addEventListener("change", function () {
      toggleGiftWrapping(this);
    });
  }
};

// ✅ Add Gift Card to Cart
let addGiftCardToCart = (wc_atc_btn) => {
  let giftCardVariant = wc_atc_btn.closest(".gift-card-content").querySelector("#giftCardVariant");
  let variant_id = giftCardVariant.options[giftCardVariant.selectedIndex].value;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variant_id, quantity: 1 }),
  })
    .then((res) => res.json())
    .then(() => {
      updateCartUI();
    })
    .catch((err) => {
      console.log("Gift card adding error", err);
    });
};

// let addtotebagToCart = (btn) => {
//   // Get variant id from button data attribute
//   let variant_id = btn.getAttribute("data-variant-id");

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Accept": "application/json"
//     },
//     body: JSON.stringify({
//       id: variant_id,
//       quantity: 1
//     }),
//   })
//     .then((res) => {
//       if (!res.ok) throw new Error("Network error adding to cart");
//       return res.json();
//     })
//     .then((data) => {
//       console.log("Added to cart:", data);
//       // Call your cart drawer refresh or update function
//       if (typeof updateCartUI === "function") {
//         updateCartUI();
//       }
//     })
//     .catch((err) => {
//       console.error("Tote bag adding error:", err);
//     });
// };

// let addFreeToteGiftToCart = (btn) => {
//   let variant_id = btn.getAttribute("data-variant-id");

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Accept": "application/json"
//     },
//     body: JSON.stringify({
//       id: variant_id,
//       quantity: 1
//     }),
//   })
//     .then((res) => {
//       if (!res.ok) throw new Error("Network error adding free tote gift");
//       return res.json();
//     })
//     .then((data) => {
//       console.log("Free tote gift added:", data);
//       if (typeof updateCartUI === "function") {
//         updateCartUI(); // ✅ Refresh cart drawer & icon
//       }
//     })
//     .catch((err) => {
//       console.error("Free tote gift add error:", err);
//     });
// };

// Function to check if tote is in cart and update button visibility
let checkToteInCart = () => {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      let toteBtn = document.querySelector(".tote_free_gift");
      if (!toteBtn) return;

      let toteVariantId = toteBtn.getAttribute("data-variant-id");
      let toteInCart = cart.items.some(item => item.variant_id == toteVariantId);

      // Hide button if tote is in cart, show if not
      if (toteInCart) {
        toteBtn.style.display = "none";
      } else {
        toteBtn.style.display = "block";
      }
    })
    .catch((err) => {
      console.error("Error checking cart:", err);
    });
};

// Add free tote gift to cart
// let addFreeToteGiftToCart = (btn) => {
//   let variant_id = btn.getAttribute("data-variant-id");

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Accept": "application/json"
//     },
//     body: JSON.stringify({
//       id: variant_id,
//       quantity: 1
//     }),
//   })
//     .then((res) => {
//       if (!res.ok) throw new Error("Network error adding free tote gift");
//       return res.json();
//     })
//     .then((data) => {
//       console.log("Free tote gift added:", data);
      
//       // Hide the button immediately after adding
//       btn.style.display = "none";
      
//       // Refresh cart UI
//       if (typeof updateCartUI === "function") {
//         console.log('---------------->')
//         updateCartUI();
//       }
      
//       // Also trigger cart check
//       checkToteInCart();
//     })
//     .catch((err) => {
//       console.error("Free tote gift add error:", err);
//     });
// };

let isAddingAutoGift = false;

// Function to automatically add free gift when threshold is met
let autoAddFreeGiftOnThreshold = () => {
  // Prevent multiple simultaneous additions
  if (isAddingAutoGift) return;
  
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      // Get gift button to check variant ID
      let giftBtn = document.querySelector(".tote_free_gift");
      if (!giftBtn) return;
      console.log('------>8989');
      let giftVariantId = giftBtn.getAttribute("data-variant-id");
      let cartTotal = cart.total_price; // Cart total in cents
      
      // Check if gift button has threshold data attribute
      let threshold = giftBtn.getAttribute("data-threshold");
      if (!threshold) {
        // If no data attribute, try to get from page
        threshold = window.thresholdInCents || 0;
      }
      
      // Check if threshold is met
      if (cartTotal >= threshold) {
        // Check if gift already in cart
        let giftInCart = cart.items.some(item => item.variant_id == giftVariantId);
        
        // If threshold met and gift NOT in cart, add it automatically
        if (!giftInCart) {
          isAddingAutoGift = true;
          console.log('id=======>',giftVariantId);
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: giftVariantId,
              quantity: 1,
              properties: {
                '_auto_added_gift': 'true' // Mark as auto-added
              }
            }),
          })
          .then((res) => {
            if (!res.ok) throw new Error("Auto add gift failed");
            return res.json();
          })
          .then((data) => {
            console.log("✅ Free gift auto-added:", data);
            
            // Hide the button
            giftBtn.style.display = "none";
            
            // Refresh cart UI
            if (typeof updateCartUI === "function") {
              updateCartUI();
            }
            
            // Reset flag after a delay
            setTimeout(() => {
              isAddingAutoGift = false;
            }, 1000);
          })
          .catch((err) => {
            console.error("Auto add gift error:", err);
            isAddingAutoGift = false;
          });
        }
      }
    })
    .catch((err) => {
      console.error("Cart fetch error:", err);
    });
};

// Enhanced updateCartUI wrapper to always check tote status
if (typeof updateCartUI !== "undefined") {
  let originalUpdateCartUI = updateCartUI;
  updateCartUI = function() {
    originalUpdateCartUI.apply(this, arguments);
    // Check tote status after cart updates
    setTimeout(() => {
      checkToteInCart();
      autoAddFreeGiftOnThreshold();
    }, 300);
  };
}

// Check tote status when page loads
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    checkToteInCart();
    // ✅ NEW: Check on page load
    autoAddFreeGiftOnThreshold();
  });
} else {
  checkToteInCart();
  autoAddFreeGiftOnThreshold();
}

// Listen for custom cart events (if your theme uses them)
document.addEventListener("cart:updated", () => {
  checkToteInCart();
  // ✅ NEW: Check on cart update
  autoAddFreeGiftOnThreshold();
});

document.addEventListener("cart:refresh", () => {
  checkToteInCart();
  // ✅ NEW: Check on cart refresh
  autoAddFreeGiftOnThreshold();
});

// Monitor cart changes via MutationObserver (backup method)
let cartObserver = new MutationObserver(() => {
  checkToteInCart();
  autoAddFreeGiftOnThreshold();
});

// Observe cart drawer if it exists
setTimeout(() => {
  let cartDrawer = document.querySelector('[data-cart-drawer], .cart-drawer, #cart-drawer');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
}, 1000);

// ✅ Run on Page Load
document.addEventListener("DOMContentLoaded", () => {
  // Initial sync with live cart data
  syncGiftWrapCheckboxWithCartLive();
  bindGiftWrappingEvent();
});

// ======================================================

// old code

// function updateCartDrawer() {
//   fetch(window.location.href)
//     .then((response) => response.text())
//     .then((html) => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, "text/html");

//       const newDrawer = doc.querySelector("#CartDrawer");
//       if (newDrawer && document.querySelector("#CartDrawer")) {
//         document.querySelector("#CartDrawer").innerHTML = newDrawer.innerHTML;
//       }

//       const newBubble = doc.querySelector("#cart-icon-bubble");
//       if (newBubble && document.querySelector("#cart-icon-bubble")) {
//         document.querySelector("#cart-icon-bubble").innerHTML =
//           newBubble.innerHTML;
//       }
//       wc_logic_for_gift_product_on_page_load();
//     });
// }

// let toggleGiftWrapping = (checkbox, event) => {
//   let wc_gift_variant_id = checkbox.value;
//   if (checkbox.checked) {
//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         id: wc_gift_variant_id,
//         quantity: 1,
//       }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         localStorage.setItem("wc_gift_wrap_product_status", true);
//         updateCartDrawer();
//       })
//       .catch((err) => {
//         localStorage.setItem("wc_gift_wrap_product_status", false);
//         let wc_gift_wrap_checkbox = document.querySelector(
//           "#giftWrappingCheckbox"
//         );
//         wc_gift_wrap_checkbox.checked = false;
//       });
//   } else {
//     fetch("/cart/change.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         id: wc_gift_variant_id,
//         quantity: 0,
//       }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         localStorage.setItem("wc_gift_wrap_product_status", false);
//         let wc_gift_wrap_checkbox = document.querySelector(
//           "#giftWrappingCheckbox"
//         );
//         wc_gift_wrap_checkbox.checked = false;
//         updateCartDrawer();
//       })
//       .catch((err) => console.error("Error:", err));
//   }
// };

// let addGiftCardToCart = () => {
//   let giftCardVariant = document.querySelector("#giftCardVariant");
//   let variant_id = giftCardVariant.options[giftCardVariant.selectedIndex].value;

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       id: variant_id,
//       quantity: 1,
//     }),
//   })
//     .then((res) => res.json())
//     .then((data) => {
//       updateCartDrawer();
//     })
//     .catch((err) => {
//       console.log("gift card adding error");
//     });
// };

// let wc_logic_for_gift_product_on_page_load = () => {
//   let wc_gift_wrap_checkbox = document.querySelector("#giftWrappingCheckbox");
//   console.log("wc_gift_wrap_checkbox", wc_gift_wrap_checkbox);
//   if (localStorage.getItem("wc_gift_wrap_product_status") == "true") {
//     wc_gift_wrap_checkbox.checked = true;
//     localStorage.setItem("wc_gift_wrap_product_status", true);
//   } else {
//     wc_gift_wrap_checkbox.checked = false;
//     localStorage.setItem("wc_gift_wrap_product_status", false);
//   }
// };
// document.addEventListener("DOMContentLoaded", function () {
//   wc_logic_for_gift_product_on_page_load();
// });

  